
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
export default Vue.extend({
  data() {
    return {
      loadingPrebuiltForms: false,
      deleteInProgress: false,
      prebuiltFormsList: [] as { _id: string; name: string; formId: string; category?: string; priority?: number }[],
      hasLoadedOnce: false,
    };
  },
  methods: {
    async getAllPrebuiltForms() {
      try {
        this.loadingPrebuiltForms = true;
        const { data } = await FormsAndSurveyServices.getPrebuiltFormsList({
          locationId: config.prebuiltFormLocation,
        });
        this.prebuiltFormsList = data.themes || data.prebuiltForms || [];
        this.hasLoadedOnce = true;
        this.loadingPrebuiltForms = false;
      } catch (error) {
        console.log(error);
        this.prebuiltFormsList = [];
        this.hasLoadedOnce = true;
        this.loadingPrebuiltForms = false;
      }
    },
    async deletePrebuiltForm(themeId: any) {
      try {
        this.deleteInProgress = true;
        await FormsAndSurveyServices.deleteThemeInForms(themeId);
        this.deleteInProgress = false;
        await this.getAllPrebuiltForms();
      } catch (error) {
        console.error(error);
        this.deleteInProgress = false;
      }
    },
  },
});
